var _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeometry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51.6 49.9",
    enableBackground: "new 0 0 51.6 49.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M33.9,49.9H16.7c-0.6,0-1-0.4-1-1V31.6c0-0.6,0.4-1,1-1h17.3c0.6,0,1,0.4,1,1v17.3 C34.9,49.4,34.5,49.9,33.9,49.9z M17.7,47.9h15.3V32.6H17.7V47.9z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M41.1,21.1c-5.8,0-10.5-4.7-10.5-10.5S35.3,0.2,41.1,0.2s10.5,4.7,10.5,10.5S46.9,21.1,41.1,21.1z  M41.1,2.2c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5s8.5-3.8,8.5-8.5S45.8,2.2,41.1,2.2z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M18.9,18.9C18.9,18.9,18.9,18.9,18.9,18.9h-18c-0.4,0-0.7-0.2-0.9-0.5c-0.2-0.3-0.2-0.7,0-1l9-17 c0.3-0.7,1.4-0.7,1.8,0l8.9,16.9c0.1,0.2,0.2,0.4,0.2,0.6C19.9,18.5,19.4,18.9,18.9,18.9z M2.6,16.9h14.6L9.9,3.1L2.6,16.9z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M38,37.9c-0.3,0-0.6-0.1-0.8-0.4c-0.4-0.4-0.3-1.1,0.1-1.4c1.3-1.1,2.5-2.4,3.4-3.8c1.8-2.8,2.9-6,3-9.3 c0-0.6,0.5-1,1-1c0.6,0,1,0.5,1,1c-0.1,3.7-1.3,7.2-3.3,10.3c-1.1,1.6-2.3,3-3.8,4.3C38.5,37.9,38.2,37.9,38,37.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M16.5,6.7c-0.4,0-0.7-0.2-0.9-0.5c-0.3-0.5-0.1-1.1,0.4-1.4c4.3-2.4,9.3-3.1,14.1-2C30.7,2.9,31,3.5,30.9,4 c-0.1,0.5-0.7,0.9-1.2,0.8c-4.3-1-8.8-0.3-12.7,1.8C16.8,6.7,16.6,6.7,16.5,6.7z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#BC9158",
    d: "M13.1,37.7c-0.2,0-0.5-0.1-0.7-0.2c-3.7-3.2-6.1-7.7-6.7-12.6c-0.1-0.8-0.2-1.7-0.2-2.5c0-0.6,0.4-1,1-1h0 c0.6,0,1,0.4,1,1c0,0.8,0,1.5,0.1,2.3c0.6,4.4,2.7,8.4,6,11.3c0.4,0.4,0.5,1,0.1,1.4C13.7,37.6,13.4,37.7,13.1,37.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeometry);
export default __webpack_public_path__ + "static/media/geometry.a7c28f4444001d588d98f2d89ce0c9f3.svg";
export { ForwardRef as ReactComponent };